import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import renderInputForField from '../helpers/renderInputForField';
import { formatLowercase } from '../../utils/stringUtils';

class EmailField extends Component {
  render() {
    const {
      fieldName = 'email',
      label = 'Email Address',
      inputCaption,
      showRequired = false,
      showLabel = true,
    } = this.props;

    const displayLabel = showLabel ? label : '';

    return (
      <Field
        name={fieldName}
        component={renderInputForField}
        label={`${displayLabel}${showRequired ? '*' : ''}`}
        format={formatLowercase}
        inputCaption={inputCaption}
        stackedlabel
        {...{
          inputProps: {
            type: 'email',
            id: fieldName,
          },
          itemProps: {},
        }}
      />
    );
  }
}

EmailField.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  inputCaption: PropTypes.string,
  showRequired: PropTypes.bool,
};

export default EmailField;
